export default __webpack_public_path__ + "media/flags/qa-b45116a3.svg";